/* =============================================================
   ODVARO - kropki postepu dla karuzel (slider-component)
   Tworzy rzad kropek pod kazda karuzela i synchronizuje je
   z przewijaniem oraz ze strzalkami prev/next.
   Ladowany z snippets/meta-tags.liquid (defer).
   ============================================================= */
(function () {
  function initSlider(sc) {
    if (sc.dataset.ovDots === '1') return;
    var slider = sc.querySelector('.slider');
    if (!slider) return;

    var slides = Array.prototype.slice.call(
      slider.querySelectorAll('.slider__slide')
    );
    if (slides.length < 2) return;

    sc.dataset.ovDots = '1';

    // ile kart widac naraz -> tyle "stron" mniej
    function perView() {
      var scLeft = slides[0].offsetLeft;
      var count = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetLeft - scLeft < slider.clientWidth - 5) count++;
      }
      return Math.max(1, count);
    }

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ov-slider-dots';

    var pages = [];
    function buildDots() {
      dotsWrap.innerHTML = '';
      pages = [];
      var pv = perView();
      var pageCount = Math.max(1, slides.length - pv + 1);
      // grupujemy: jedna kropka na jedno przesuniecie o karte
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ov-slider-dot';
        dot.setAttribute('aria-label', 'Przejdz do pozycji ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            slider.scrollTo({
              left: slides[idx].offsetLeft - slides[0].offsetLeft,
              behavior: 'smooth'
            });
          });
        })(i);
        dotsWrap.appendChild(dot);
        pages.push(slides[i]);
      }
    }

    buildDots();

    // wstawiamy kropki po przyciskach strzalek albo na koncu komponentu
    var btns = sc.querySelector('.slider-buttons');
    if (btns && btns.parentNode) {
      btns.parentNode.insertBefore(dotsWrap, btns.nextSibling);
    } else {
      sc.appendChild(dotsWrap);
    }

    function activeIndex() {
      var pos = slider.scrollLeft + slides[0].offsetLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < pages.length; i++) {
        var d = Math.abs(pages[i].offsetLeft - pos);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function sync() {
      var a = activeIndex();
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === a);
      }
    }

    sync();

    var raf;
    slider.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });

    var rebuildTimer;
    window.addEventListener('resize', function () {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(function () {
        buildDots();
        sync();
      }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // sekcje dogrywane w edytorze motywu
  document.addEventListener('shopify:section:load', initAll);
})();
